import React from 'react'
import {Link} from 'react-router-dom'
import './style.css'

export default function comp_prod() {
    return (
        <div className="transaksi-cart-product">
            <div className="product">
                <img src="asset/product/kitab.png" alt="kitab" />
                <div className="text-product">
                    <p>Dipesan dari <span>Cordova</span></p>
                    <small>Kode Pemesanan : <span>192401sf9149s</span></small>
                    <h6>Kitab Riyadhus Shalihin (1)</h6>
                    <Link className="link" to="#">Lihat semua barang yang dipesan (4)</Link>
                </div>
            </div>
        </div>
    )
}
